import { render, staticRenderFns } from "./SubPageLayout.vue?vue&type=template&id=1e0b0fd4&scoped=true&"
import script from "./SubPageLayout.vue?vue&type=script&lang=js&"
export * from "./SubPageLayout.vue?vue&type=script&lang=js&"
import style0 from "./SubPageLayout.vue?vue&type=style&index=0&id=1e0b0fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0b0fd4",
  null
  
)

export default component.exports